import { SpecAnalytics } from '../specUtils';
import { UserBase } from '../user';
import { createEventTracker } from '../util';
import {
  SpaceAnalytics,
  SpaceCardAnalytics,
  SpaceCardRemoveAnalytics,
  SpaceCardReorderAnalytics,
  SpaceDeletedAnalytics,
  SpaceObjectAnalytics,
  SpaceTransferObjectAnalytics,
  SpacesBetaFeedback,
} from './types';

export const trackSpaceCreated = createEventTracker<SpaceAnalytics & UserBase>('Space Created');
export const trackSpaceUpdated = createEventTracker<SpaceAnalytics & UserBase>('Space Updated');
export const trackSpaceDeleted = createEventTracker<SpaceDeletedAnalytics & UserBase>(
  'Space Deleted',
);
export const trackSpaceAddCard = createEventTracker<SpaceCardAnalytics & SpecAnalytics & UserBase>(
  'Space Add Feature Card',
);
export const trackSpaceDuplicateCard = createEventTracker<SpaceCardAnalytics & UserBase>(
  'Space duplicate Feature Card',
);
export const trackSpaceUpdateCard = createEventTracker<SpaceCardAnalytics & UserBase>(
  'Space Update Feature Card',
);
export const trackSpaceRemoveCard = createEventTracker<SpaceCardRemoveAnalytics & UserBase>(
  'Space Remove Feature Card',
);
export const trackSpaceCardReorder = createEventTracker<SpaceCardReorderAnalytics & UserBase>(
  'Space Card Reorder',
);

export const trackSpaceTransferObject = createEventTracker<SpaceTransferObjectAnalytics & UserBase>(
  'Space Transfer Object',
);
export const trackSpaceAddObject = createEventTracker<SpaceObjectAnalytics & UserBase>(
  'Space Add Object',
);
export const trackSpaceSaveObject = createEventTracker<SpaceObjectAnalytics & UserBase>(
  'Space Save Object',
);

export const trackSpacesBetaFeedback =
  createEventTracker<SpacesBetaFeedback>('Spaces Beta Feedback');
